import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { gray, grayTextFilter, violet } from '@qirapagos/lib/theme/colors'

function ChartUpIcon({
  active,
  canBeHovered
}: {
  active: boolean
  canBeHovered?: boolean
}) {
  const strokeColor = !canBeHovered ? grayTextFilter : active ? violet : gray

  return (
    <Svg width={25} height={25} viewBox="0 0 25 25" fill="none">
      <Path
        d="M21.5 20H3.5V5"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.0002 6.5L12.5002 14L9.50024 11L3.50024 17"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.0002 10.25V6.5H16.2502"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

ChartUpIcon.defaultProps = {
  canBeHovered: true
}

export default ChartUpIcon
